/**
 * Xignite to Standard exchange mapping
 * @param exchange
 * @return {*}
 * @private
 */
export const getXigniteToStandard = (exchange) => {
  switch (exchange) {
    case 'XNYS':
    case 'NYS':
      return 'NYSE'
    case 'XNAS':
    case 'NAS':
      return 'NASDAQ'
    case 'XTSE':
    case 'TSE':
      return 'TSX'
    case 'XTSX':
    case 'TSX':
      return 'TSX-V'
    case 'XASE':
    case 'ASE':
      return 'NYSEMKT'
    case 'ARCX':
      return 'NYSEARCA'
    case 'XLON':
    case 'LON':
      return 'LSE'
    case 'XSTO':
    case 'STO':
      return 'OME'
    case 'XMIL':
      return 'MIL'
    case 'XSWX':
      return 'SWX'
    case 'XETR':
      return 'ETR'
    case 'XASX':
      return 'ASX'
    case 'XPAR':
      return 'PAR'
    case 'XAMS':
      return 'AMS'
    default:
      return (exchange && exchange.charAt(0).toLocaleLowerCase() === 'x'
          ? exchange.substr(1)
          : exchange
      )
  }
}